import { render, staticRenderFns } from "./GrantHeader.vue?vue&type=template&id=f3b48e8a&scoped=true&"
import script from "./GrantHeader.vue?vue&type=script&lang=js&"
export * from "./GrantHeader.vue?vue&type=script&lang=js&"
import style0 from "./GrantHeader.vue?vue&type=style&index=0&id=f3b48e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b48e8a",
  null
  
)

export default component.exports